import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    HistoryAccountDetailsColumn,
    HistoryAccountDetailsView,
    HistoryAccountTableKind,
} from "./historyAccountDetailsView";

const IDENTITY_COLUMNS = [
    HistoryAccountDetailsColumn.IDENTIFIER,
    HistoryAccountDetailsColumn.GROUP,
    HistoryAccountDetailsColumn.ENTITY,
];

const CHANGE_COLUMNS = [
    HistoryAccountDetailsColumn.PREVIOUS,
    HistoryAccountDetailsColumn.MODIFIED,
];

const COLUMNS_BY_KIND: Record<
    HistoryAccountTableKind,
    HistoryAccountDetailsColumn[]
> = {
    [HistoryAccountTableKind.IDENTITY]: [
        HistoryAccountDetailsColumn.TIME,
        ...IDENTITY_COLUMNS,
    ],
    [HistoryAccountTableKind.CHANGE]: [
        HistoryAccountDetailsColumn.TIME,
        ...IDENTITY_COLUMNS,
        ...CHANGE_COLUMNS,
    ],
    [HistoryAccountTableKind.MERGE]: [
        HistoryAccountDetailsColumn.TIME,
        ...IDENTITY_COLUMNS,
    ],
    [HistoryAccountTableKind.GROUP_DELETE]: [
        HistoryAccountDetailsColumn.TIME,
        ...IDENTITY_COLUMNS,
        ...CHANGE_COLUMNS,
    ],
};

export const createDefaultHistoryAccountDetailsView = (
    kind: HistoryAccountTableKind,
): HistoryAccountDetailsView => ({
    type: ViewType.HISTORY_UPDATED_TRANSACTION,
    columns: COLUMNS_BY_KIND[kind].map((id) => ({ id })),
    filters: {},
    options: {
        selection: true,
        density: ViewDensity.MD,
    },
});
